import React, { Component } from 'react';
import SubPageTopBar from '../../../Shared/SubPageTopBar/SubPageTopBar';
import * as api from '../../../../api';
import * as utils from '../../../../utils';
import './ProjectInfo.css';
import { ASSETS_FOLDER } from '../../../../constants';
import { INFO } from '../../../../texts';
import InfoPhoto from './InfoPhoto/InfoPhoto';
import InfoCt0 from './InfoCt0/InfoCt0';
import InfoCtVideo from './InfoCtVideo/InfoCtVideo';
import InfoCt1 from './InfoCt1/InfoCt1';

class ProjectInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      data: [],
    };
  }

  componentDidMount() {
    utils.scrollToTop();
    api
      .getInfoData()
      .then(data => {
        this.setState({
          fetching: false,
          data,
        });
      })
      .catch(() => {
        // note - solve error state (not really needed in this case)
      });
  }

  render() {
    const { fetching, data } = this.state;
    return (
      <div
        id="project-info"
        style={{
          background: `#3a3730 url(${`${ASSETS_FOLDER}info/bg-tile.jpg`}) repeat`,
        }}
      >
        <SubPageTopBar />
        <img
          id="info-logo"
          src={`${ASSETS_FOLDER}info/logo.png`}
          alt={INFO.ALT1}
        />
        <div id="info-data">
          {!fetching && (
            <React.Fragment>
              <div id="info-title">
                <div id="info-title-text">
                  <h2>
                    <strong>{data.desc[0]}</strong>
                    {` ${data.desc[1]}`}
                    <strong>{data.desc[2]}</strong>
                    {` ${data.desc[3]}`}
                  </h2>
                </div>
                <img
                  id="info-prix-logo"
                  src={`${ASSETS_FOLDER}info/logo-prix.png`}
                  alt=""
                />
              </div>
              <div className="h-spacer" />
              <div id="info-photos">
                <div className="photos-section">
                  <h3>{data.group1.title}</h3>
                  <div>
                    <InfoPhoto id={0} name={data.group1.names[0]} />
                    <InfoPhoto id={1} name={data.group1.names[1]} />
                    <InfoPhoto id={2} name={data.group1.names[2]} />
                    <InfoPhoto id={3} name={data.group1.names[3]} />
                  </div>
                </div>
                <div className="photos-section">
                  <h3>{data.group2.title}</h3>
                  <InfoPhoto id={4} name={data.group2.name} />
                </div>
              </div>
              <div className="h-spacer" />
              <div id="info-ct">
                <h3>{data.ct.title}</h3>
                <div>
                  <InfoCt0 data={data.ct.group0} />
                  <div className="v-spacer" />
                  <InfoCtVideo data={data.ct.groupVideo} />
                  <div className="v-spacer" />
                  <InfoCt1 data={data.ct.group1} />
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
        <img
          id="info-bottom-deco"
          src={`${ASSETS_FOLDER}info/deco-bottom.jpg`}
          alt={INFO.ALT2}
        />
      </div>
    );
  }
}

export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/ProjectInfo/ProjectInfo.js